import { createContext } from "react";

export const ListasDetContext = createContext()
export const ListasDetFormContext = createContext()
export const ListasDetReportContext = createContext()